import { PATIENT_WAITING_LIST } from "@/api_framework/api_config";
import { IPatientWaitingListPetReadyWhatsapp } from "@/api_framework/api_modals/Patients";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
export interface IPatientWaitingSendWhatsApp {
  user_id: string;
}
export const usePatientWaitingPetReadyAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const configuration = useConfiguration();
  const execute = useCallback(
    async (filter: IPatientWaitingSendWhatsApp) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        await axios
          .post(PATIENT_WAITING_LIST?.WAITING_LIST_PET_READT_WHATSAPP?.baseURL ?? "", filter, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IPatientWaitingListPetReadyWhatsapp>) => {
            if (res.data.status === true) {
              toast.success("sending whatsApp to the client");
              // dispatch(
              //   setPatientWaitingStats({
              //     data: res.data.data,
              //   }),
              // );
              // dispatch(
              //   setLoading({
              //     key: "isPWLStatsFetchInProgress",
              //     status: false,
              //   }),
              // );
            } else {
              // dispatch(
              //   setPatientWaitingStats({
              //     data: [],
              //   }),
              // );
              // dispatch(
              //   setLoading({
              //     key: "isPWLStatsFetchInProgress",
              //     status: false,
              //   }),
              // );
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e)
          });
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return execute;
};
